import Fetch from "@src/API/Fetch.js"
import Format from "@src/utils/Format.js"

export default async function Load(id, name) {
  let result = await Fetch("GET", `node/${id}/pdf`, null, null, name)
  
  return await Format("tree", result);
}